export const enum SessionStatus {
  CREATED = 'created',
  ENTERED = 'entered',
  ERROR = 'error',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  AUTHENTICATED = 'authenticated',
  EXPIRED = 'expired',
}

export const enum LoginSessionType {
  REGISTER = 'register',
  LOGIN = 'login',
  CHECKOUT = 'checkout',
  SELF_SERVICE = 'selfService',
}
